"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LeaderboardIndividualItem = LeaderboardIndividualItem;
exports.default = void 0;
var _Box2 = _interopRequireDefault(require("@mui/material/Box"));
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _Skeleton2 = _interopRequireDefault(require("@mui/material/Skeleton"));
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _hooks = require("../../../hooks");
var _user = require("../../user");
var _medals = require("../medals");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function LeaderboardIndividualItem({
  blurred,
  challengeType,
  item,
  prevItemRank
}) {
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const {
    getProgressValueWithUnit
  } = (0, _hooks.useChallenge)();
  const medal = item && _medals.medals[item.rank - 1] || null;
  return /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    display: "flex",
    gap: 1,
    paddingX: 2,
    paddingY: 1,
    sx: blurred ? {
      filter: 'blur(0.25rem)'
    } : {}
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexShrink: 0,
    height: 24,
    justifyContent: "center",
    width: 30
  }, !item ? /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    variant: "text",
    width: 24
  }) : item.rank === prevItemRank ? /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    align: "center",
    fontWeight: 700
  }, "-") : medal ? /*#__PURE__*/_react.default.createElement("img", {
    src: medal.icon,
    width: 24
  }) : /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    align: "center",
    fontWeight: 700
  }, Math.max(item.rank, item.leaderboardIndex || 0))), /*#__PURE__*/_react.default.createElement(_user.UserAvatar, {
    size: 48,
    user: item?.user
  }), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    fontWeight: 700,
    variant: "body2"
  }, item ? item.user?.username || t('commons.news.deleted_user') : /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    variant: "text",
    width: 200
  }))), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    flexShrink: 0
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    noWrap: true,
    variant: "body2"
  }, item ? getProgressValueWithUnit(challengeType || 'bttf', item.progressValue) : /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    variant: "text",
    width: 100
  }))));
}
var _default = exports.default = LeaderboardIndividualItem;